import type { DemoSourceSummary, DemoToneAnalysisFormValues } from '../models/demoToneAnalysis'
import type { ToneAnalysisRequest } from '../models/toneAnalysis'

export function buildToneAnalysisRequest(values: DemoToneAnalysisFormValues): ToneAnalysisRequest {
  const source = values.sourceMode === 'youtube'
    ? {
        sourceType: 'RemoteUrl' as const,
        location: values.youtubeUrl.trim(),
        originalFileName: undefined,
        contentType: undefined,
      }
    : {
        sourceType: 'LocalFile' as const,
        location: values.selectedFile?.name ?? '',
        originalFileName: values.selectedFile?.name,
        contentType: values.selectedFile?.type || 'audio/*',
      }

  return {
    songTitle: values.songTitle.trim(),
    artist: values.artist.trim() || undefined,
    presetBaseName: values.presetBaseName.trim(),
    audioSource: source,
    analysisOptions: {
      detectMultipleGuitarLayers: values.maximumGuitarLayers === 2,
      detectToneChanges: true,
      maximumGuitarLayers: values.maximumGuitarLayers,
      reuseSimilarScenes: true,
      sceneSimilarityThreshold: 0.85,
    },
  }
}

export function getDemoSourceSummary(values: DemoToneAnalysisFormValues): DemoSourceSummary {
  if (values.sourceMode === 'youtube') {
    return {
      type: 'YouTube link',
      name: values.youtubeUrl.trim(),
    }
  }

  return {
    type: 'Audio file',
    name: values.selectedFile?.name ?? '',
  }
}
